import React from "react";

export default function ModalClose() {
  return (
    <svg viewBox="0 0 114 114" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#a)">
        <circle
          cx="56.568"
          cy="56.568"
          r="40"
          transform="rotate(135 56.568 56.568)"
          fill="#fff"
          fillOpacity=".9"
        />
      </g>
      <path
        d="M45.607 44.901 68.235 67.53m-.001-22.629L45.607 67.53"
        stroke="#1F2022"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <defs>
        <filter
          id="a"
          x=".568"
          y=".568"
          width="112"
          height="112"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_3341_2905"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend
            in2="effect1_backgroundBlur_3341_2905"
            result="effect2_dropShadow_3341_2905"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_3341_2905"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
